import { render, staticRenderFns } from "./CocinaeasylunchreporteAutomodal.vue?vue&type=template&id=8dd6fb24&"
import script from "./CocinaeasylunchreporteAutomodal.vue?vue&type=script&lang=js&"
export * from "./CocinaeasylunchreporteAutomodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports